import { readEntry, writeEntry } from './db';

/**
 * Estado lançado offline e ainda não enviado.
 *
 * Sem isto, o técnico salva uma sessão sem sinal, sai da tela e volta — e vê a
 * versão antiga do servidor, como se o que ele digitou tivesse sumido.
 *
 * Funciona porque as sessões de workflow entram e saem no MESMO formato: o que
 * `saveOPUData` recebe é o que `loadOPUData` devolve. Dá para guardar o que foi
 * salvo e servir de volta sem traduzir nada, sem duplicar mapeamento.
 *
 * Vive no mesmo store do cache, com prefixo próprio, e é apagado quando o item
 * correspondente sai da fila.
 */

const key = (kind, id) => `pendente:${kind}:${id}`;

export const setPending = (kind, id, data) => writeEntry(key(kind, id), data);

export const getPending = (kind, id) =>
  readEntry(key(kind, id)).then(entry => (entry ? entry.data : null));

export const pendingKeyOf = key;

/** Recebe a chave já montada, como guardada no registro da fila. */
export const clearPending = (fullKey) => writeEntry(fullKey, null);

export const hasPending = (kind, id) =>
  getPending(kind, id).then(v => v != null);
